module.exports = __webpack_public_path__ + "static/media/app-store-es.ebdcadff.svg";